import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "../components/home/HeroSection";
import AboutSection from "../components/home/About";
import SchedulePage from "./Schedule";
import TravelPage from "./Travel";
import RSVPPage from "./Rsvp";
import RegistrySection from "../components/home/RegistrySection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    // Handle scroll to section from navigation
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location.state]);

  return (
    <div>
      {/* Hero Section */}
      <section id="home">
        <HeroSection />
      </section>

      {/* About Section */}
      <section id="about">
        <AboutSection />
      </section>

      {/* Schedule Section */}
      <section id="schedule">
        <SchedulePage />
      </section>

      {/* Travel Section */}
      <section id="travel">
        <TravelPage />
      </section>

      {/* Registry Section */}
      <section id="registry">
        <RegistrySection />
      </section>

      {/* RSVP Section */}
      <section id="rsvp">
        <RSVPPage />
      </section>
    </div>
  );
}
